import { lazy } from "react";

export const Login = lazy(() => import("./Login/Login"));

export const ForgotPassword = lazy(() =>
	import("./ForgotPassword/ForgotPassword")
);

export const ResetPassword = lazy(() =>
	import("./ResetPassword/ResetPassword")
);

export const MyAccount = lazy(() => import("./MyAccount/MyAccount"));

export const MyNotifications = lazy(() =>
	import("./MyAccount/MyNotifications")
);

export const ChangePassword = lazy(() =>
	import(
		"./AdminManagement/ChangePasswordFormBuilder/ChangePasswordFormBuilder"
	)
);

export const MasterAuditTrail = lazy(() =>
	import("./AdminManagement/MasterAuditTrail/MasterAuditTrail")
);

export const MasterData = lazy(() =>
	import("./AdminManagement/MasterDataBuilder/MasterDataBuilder")
);

export const CMSAccounts = lazy(() =>
	import("./CMSAccountManagement/CMSAccountManagement")
);

export const AddCMSAccount = lazy(() =>
	import("./CMSAccountManagement/CreateCMSAccount")
);

export const EditCMSAccountDetails = lazy(() =>
	import("./CMSAccountManagement/EditCMSAccount")
);

export const RoleManagement = lazy(() =>
	import("./CMSAccountManagement/RoleManagement")
);

export const CreateNewRole = lazy(() =>
	import("./CMSAccountManagement/CreateRole")
);

export const EditRole = lazy(() => import("./CMSAccountManagement/EditRole"));

export const PushNotifications = lazy(() =>
	import("./CMSAccountManagement/PushNotifications")
);

export const CreatePushNotification = lazy(() =>
	import("./CMSAccountManagement/CreateNotification")
);

export const PushNotificationDetails = lazy(() =>
	import("./CMSAccountManagement/EditNotification")
);

export const MasterDataManagement = lazy(() =>
	import("./MasterDataManagement/MasterDataMangement")
);

export const BannerListing = lazy(() =>
	import("./BannerManagement/BannerListing/BannerListing")
);
export const AddBanner = lazy(() =>
	import("./BannerManagement/AddBanner/AddBanner")
);
export const EditBanner = lazy(() =>
	import("./BannerManagement/EditBanner/EditBanner")
);



export const ServiceListing = lazy(() =>
	import("./ServiceManagement/ServiceListing/ServiceListing")
);
export const AddService = lazy(() =>
	import("./ServiceManagement/AddService/AddService")
);
export const EditService = lazy(() =>
	import("./ServiceManagement/EditService/EditService")
);

export const TechnologyListing = lazy(() =>
	import("./TechnologyManagement/TechnologyListing/TechnologyListing")
);

export const AddTechnology = lazy(() =>
	import("./TechnologyManagement/AddTechnology/AddTechnology")
);
export const EditTechnology = lazy(() =>
	import("./TechnologyManagement/EditTechnology/EditTechnology")
);

export const BrandListing = lazy(() =>
	import("./BrandManagement/BrandListing/BrandListing")
);
export const AddBrand = lazy(() =>
	import("./BrandManagement/AddBrand/AddBrand")
);
export const EditBrand = lazy(() =>
	import("./BrandManagement/EditBrand/EditBrand")
);

export const MottoListing = lazy(() =>
	import("./MottoManagment/MottoListing/MottoListing")
);

export const FeatureListing = lazy(() =>
	import("./FeatureManagement/FeatureListing/FeatureListing")
);

export const CareerListing = lazy(() =>
	import("./CareerManagement/CareerLisitng/CareerListing")
);
export const AddCareer = lazy(() =>
	import("./CareerManagement/AddCareer/AddCareer")
);
export const EditCareer = lazy(() =>
	import("./CareerManagement/EditCareer/EditCareer")
);

//journey
export const JourneyListing = lazy(() =>
	import("./JourneyManagement/JourneyListing/JourneyListing")
);
export const AddJourney = lazy(() =>
	import("./JourneyManagement/AddJourney/AddJourney")
);
export const JourneyDetail = lazy(() =>
	import("./JourneyManagement/JourneyDetail/JourneyDetail")
);
export const EditJourney = lazy(() =>
	import("./JourneyManagement/EditJourney/EditJourney")
);

//Branch
export const BranchListing = lazy(() =>
	import("./BranchManagement/BranchListing/BranchListing")
);
export const AddBranch = lazy(() =>
	import("./BranchManagement/AddBranch/AddBranch")
);
export const EditBranch = lazy(() =>
	import("./BranchManagement/EditBranch/EditBranch")
);

export const AdminListing = lazy(() =>
	import("./AdminManagement/AdminListing/AdminListing")
);

//Csr
export const CSRListing = lazy(() =>
	import("./CSRManagement/CSRListing/CSRListing")
);
export const AddCSR = lazy(() => import("./CSRManagement/AddCSR/AddCSR"));
export const EditCSR = lazy(() => import("./CSRManagement/EditCSR/EditCSR"));
export const CSRDetail = lazy(() =>
	import("./CSRManagement/CSRDetail/CSRDetail")
);
export const AddSubCSR = lazy(() =>
	import("./CSRManagement/SubCSRs/AddSubCSR/AddSubCSR")
);
export const EditSubCSR = lazy(()=> import("./CSRManagement/SubCSRs/EditSubCSR/EditSubCSR"))

export const BusinessUnitListing = lazy(() =>
	import("./BusinessUnitManagement/BusinessUnitListing/BusinessUnitListing")
);
export const AddBusinessUnit = lazy(()=> import("./BusinessUnitManagement/AddBusinessUnit/AddBusinessUnit"));
export const EditBusinessUnit = lazy(()=> import("./BusinessUnitManagement/EditBusinessUnit/EditBusinessUnit"));
export const BusinessUnitDetail = lazy(() =>
	import("./BusinessUnitManagement/BusinessUnitDetail/BusinessUnitDetail")
);

export const ContactMessageListing = lazy(() =>
	import(
		"./ContactMessageManagement/ContactMessageListing/ContactMessageListing"
	)
);
